"use client";
import { createThemeFactory } from '../shared/create-theme-factory';
import { createOptions as createBaseOptions } from "./base/create-options";
import { createOptions as createDarkOptions } from "./dark/create-options";
import { createOptions as createLightOptions } from "./light/create-options";
import { createTypography } from "./base/create-typography";

export const COMPONENTS = {
  // Source-of-truth minHeight applied to the top-nav Stack (see top-nav.jsx).
  TOP_NAV_HEIGHT: 64,
  // Effective vertical space the rendered top-nav occupies, including the
  // sticky shadow / icon-button visual footprint. Empirically determined
  // by inspecting overflow at runtime: 64 leaves a 16px overflow, 80 fits
  // the viewport cleanly. Use this for `100vh - X` page-area calculations.
  TOP_NAV_OFFSET: 80,
  SIDE_NAV_WIDTH: 280,
  MOBILE_NAV_WIDTH: 280,
};

export const createTheme = createThemeFactory({
  createBaseOptions,
  createDarkOptions,
  createLightOptions,
  createTypography,
});

export const theme = createTheme({});

